import React, { memo, useCallback } from 'react'
import { css } from '@emotion/css'
import { pick } from 'lodash-es'
import { Modal } from '@mantine/core'
import { RichTextEditor } from '@mantine/rte'
import { Button } from '@ow/comps'
import useAppListStore from './appListStore'
import { ModalStyle } from './styled/global'

const ContentEditModal = ({ target }) => {
  const { contentEditOpened, content, setState, updateApp, loading } =
    useAppListStore((state) =>
      pick(state, [
        'contentEditOpened',
        'setState',
        'content',
        'updateApp',
        'loading',
      ])
    )
  const onChange = useCallback(
    (v) => {
      setState({ content: v })
    },
    [setState]
  )
  const onClose = useCallback(() => {
    setState({ contentEditOpened: false })
  }, [setState])
  const submit = async () => {
    if (await updateApp({ description: content })) {
      onClose()
    }
  }
  return (
    <Modal
      opened={contentEditOpened}
      onClose={onClose}
      title="项目说明"
      size="76%"
      target={target}
      closeOnClickOutside={false}
      centered
    >
      <ModalStyle />
      <RichTextEditor
        className={css`
          margin: 20px 0;
          min-height: 340px;
        `}
        value={content}
        onChange={onChange}
      />
      <div className="flex justify-end gap-4">
        <Button type="primary" onClick={submit} loading={loading}>
          确 定
        </Button>
        <Button stroke onClick={onClose}>
          取 消
        </Button>
      </div>
    </Modal>
  )
}

export default memo(ContentEditModal)
